module.exports = __webpack_public_path__ + "static/media/hollow_end_bar.acf1a19e.svg";